import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BankAccountsListSearchRequest } from "../api-interfaces";

interface BankAccountsList {
  searchCriteria: BankAccountsListSearchRequest;
}

export const INITIAL_SEARCH_CRITERIA: BankAccountsListSearchRequest = {
  applicantCompanyName: "",
  referenceGroupName: "",
  ipid: "",
  merchantName: "",
  timestamp: -1,
};

const initialState: BankAccountsList = {
  searchCriteria: INITIAL_SEARCH_CRITERIA,
};

const bankAccountsSearchConditionSlice = createSlice({
  name: "bankAccountsList",
  initialState,
  reducers: {
    setSearchCondition: (
      state,
      action: PayloadAction<BankAccountsListSearchRequest>
    ) => {
      state.searchCriteria = action.payload;
    },
  },
});

export const { setSearchCondition } = bankAccountsSearchConditionSlice.actions;

export default bankAccountsSearchConditionSlice.reducer;
